import { configureStore } from "@reduxjs/toolkit";
import LayoutSlice from "./Reducers/LayoutSlice";
import BookmarkHeaderSlice from "./Reducers/BookmarkHeaderSlice";
import ThemeCustomizerSlice from "./Reducers/ThemeCustomizerSlice";
import FormWizardTwoSlice from "./Reducers/FormWizardTwoSlice";
import NumberingWizardSlice from "./Reducers/NumberingWizardSlice";
import StudentWizardSlice from "./Reducers/StudentWizardSlice";
import VerticalWizardSlice from "./Reducers/VerticalWizardSlice";
import TwoFactorSlice from "./Reducers/TwoFactorSlice";
import ProjectSlice from "./Reducers/ProjectSlice";
import ToDoSlice from "./Reducers/ToDoSlice";
import TasksSlice from "./Reducers/TasksSlice";
import ContactSlice from "./Reducers/ContactSlice";
import BookmarkTabSlice from "./Reducers/BookmarkTabSlice";
import LetterBoxSlice from "./Reducers/LetterBoxSlice";
import ChatSlice from "./Reducers/ChatSlice";
import AddProductSlice from "./Reducers/AddProductSlice";
import ProductSlice from "./Reducers/ProductSlice";
import FilterSlice from "./Reducers/FilterSlice";
import CartSlice from "./Reducers/CartSlice";

const Store = configureStore({
  reducer: {
    layout: LayoutSlice,
    bookmarkHeader:BookmarkHeaderSlice,
    themeCustomizer: ThemeCustomizerSlice,
    formWizardTwo:FormWizardTwoSlice,
    numberingWizard: NumberingWizardSlice,
    studentWizard: StudentWizardSlice,
    verticalWizard: VerticalWizardSlice,
    twoFactor: TwoFactorSlice,
    project:ProjectSlice,
    todo:ToDoSlice,
    tasks:TasksSlice,
    contact:ContactSlice,
    bookmarkTab:BookmarkTabSlice,
    letterBox:LetterBoxSlice,
    chatData: ChatSlice,
    addProduct:AddProductSlice,
    product:ProductSlice,
    filterData: FilterSlice,
    cartData: CartSlice,
  },
});

export default Store;

export type RootState = ReturnType<typeof Store.getState>;
export type AppDispatch = typeof Store.dispatch;
